import { render, staticRenderFns } from "./AdacOptin.vue?vue&type=template&id=2ef88242&scoped=true&"
import script from "./AdacOptin.vue?vue&type=script&lang=js&"
export * from "./AdacOptin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef88242",
  null
  
)

export default component.exports